declare namespace $ {

	type $mol_select__Filter_shm_mentionstat_chart_1 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__value_shm_mentionstat_chart_2 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_chart['group'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_mentionstat_chart_3 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_chart['group_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_view__sub_shm_mentionstat_chart_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_mentionstat_chart extends $shm_wordstat_chart_timeseries {
		group_period_kind( ): string
		group( next?: string ): string
		Group_select( ): $mol_select
		Tools( ): $mol_view
		group_options( ): Record<string, any>
		period_kind( ): ReturnType< $shm_mentionstat_chart['group_period_kind'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chart.view.tree.d.ts.map